import { PermissionsSet } from "../entities/permissions-set";

export class PermissionsSetService {
  private permissionsSet: PermissionsSet;

  constructor(permissionsSet: PermissionsSet = new Set<string>([])) {
    this.permissionsSet = permissionsSet;
  }

  public getPermissionsSet(): PermissionsSet {
    return this.permissionsSet;
  }

  public setPermissionsSet(permissions: PermissionsSet): void {
    this.permissionsSet = permissions;
  }

  public hasPermission(permission: string): boolean {
    return this.permissionsSet.has(permission);
  }

  public clearPermissions(): void {
    this.permissionsSet.clear();
  }
}
